
import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Form
} from "react-bootstrap"; // popup
import { useForm, Controller } from "react-hook-form";
import SunEditor from "suneditor-react";
import plugins from "suneditor/src/plugins";
import { en } from "suneditor/src/lang";
import "suneditor/dist/css/suneditor.min.css";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, CircularProgress, Button, Card, FormControl, InputLabel, Select, MenuItem, TextField, Grid, Divider, IconButton } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { IconCheck, IconX, IconXboxX } from "@tabler/icons-react";
import ScheduleDemo from "./demo";
import Cookies from 'js-cookie';
const CreateTicket = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
        control,
        clearErrors,
        setValue,
        getValues,
        setError,
        trigger,
    } = useForm();
    const [isLoadingCreate, setIsLoadingCreate] = useState();
    const [showCommentAndFile, setShowCommentAndFile] = useState(false);
    const [getParentTicket, setGetParentTicket] = useState("");
    const [getChildTicket, setGetChildTicket] = useState("");
    const [secondFormErrors, setSecondFormErrors] = useState({});
    const [imageData, setImageData] = useState([]);
    const [formValues3, setFormValues3] = useState([]);
    const [error1, seterror1] = useState("");
    const [disable, setDisable] = useState(false);
    const navigate = useNavigate();


    const getparentTicketData = async () => {
        try {
            // axios.defaults.headers.common = { 'Authorization': `` }
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL2}/apiV1/get_ticket_parent_category/`,
                {
                    headers: {
                        Authorization: '',
                    },
                }
            );
            setGetParentTicket(response.data.results);
        } catch (error) {
            console.log(error);
        }
    };

    const parentTicketChange = async (id) => {
        try {
            // axios.defaults.headers.common = { 'Authorization': `` }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get_ticket_category/?parent_category=${id}`,
                {
                    headers: {
                        Authorization: '',
                    },
                }
            );
            setGetChildTicket(response.data.results);
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        getparentTicketData();
    }, []);

    const [imgErrorMsgPopUpText, setImgErrorMsgPopUpText] = useState('');
    const [HaveImage, setHaveImage] = useState(false);
    const [PoliciesfilesErrorMessage, setPoliciesfilesErrorMessage] = useState();
    const [imageName, setImageName] = useState('');
    const [file, setFile] = useState(null);
    const [success, setSucess] = useState(false);
    const [error, seterror] = useState("")
    const [nocallapi, setnocallapi] = useState(false)
    const [buttonDisable, setButtonDisable] = useState(false)
    const [documents, setDocuments] = useState([]);
    const [selectedFileNames, setSelectedFileNames] = useState([]);
    const [fileObjects, setFileObjects] = useState([null, null, null, null]);
    const [sizepoup, setSizePop] = useState(false);
    const [ProfileData, setProfileData] = useState([]);
    const GetData = async () => {
        try {
            const response = await axios.get('/apiV1/get-profile/');
            if (response.status === 200) {
                setProfileData(response.data.message);
            }
        } catch (error) {
        console.error("Error fetching profile data:", error.response ? error.response.data : error.message);
        }
    };
    useEffect(() => {
        GetData();
    }, []);
    const postTicketCreated = async (data) => {
        if (fileError) {
            setSizePop(true)
            return;
        }
      const rawDesc = data?.ticket_desc || '';
                const cleaned = rawDesc.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();

                if (!cleaned) {
                    setError('ticket_desc', {
                        type: 'manual',
                        message: 'Comment is required',
                    });
                    return;
                }

        setButtonDisable(true);
        const userinfo = JSON.parse(Cookies.get("user-info"))
        const formData = new FormData();
        formData.append("ticket_category_id", data.ticket_category_id);
        formData.append("ticket_sub_category_id", data.sub_category_id);
        formData.append("ticket_desc", data.ticket_desc);
        formData.append("user_email", ProfileData.email);
        formData.append("employee_number", userinfo.id);
        formData.append("user_name", ProfileData.fullname);
        formData.append("company_name", ProfileData.company_name);
        formData.append("id", userinfo.id);
        documents.forEach((file) => {
            formData.append("files", file);
        });

        try {
            const config2 = {
                headers: {
                    Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
                },
            };
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/create_ticket/`, formData,config2);
            console.log(response.data);
            setDocuments([]);
            setSelectedFileNames([]);
            setShowCommentAndFile(false);
            setSucess(true);
            setValue("ticket_desc", "Please type here...");
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setButtonDisable(false);
        }
    };


    const onImageValue = (data) => {
        setError('certificateFile', { type: 'custom', message: "" });
        // setRemoveComanyFileValue(true)
        setHaveImage(false)
        setnocallapi(false)
        const updatedImageValue = data.target.files[0].name
        console.log(updatedImageValue, "aaaa")
        let file = data.target.files[0];
        let reader = new FileReader();
        reader.onload = function (e) {
            setFile(e.target.result);
        };
        reader.readAsDataURL(data.target.files[0]);

        if (file.size > 2e6) {
            // setImgErrorMsgPopUp(true)
            // setTimeout(() => { setImgErrorMsgPopUp(false) }, 3000);
            setImgErrorMsgPopUpText("Please upload a file smaller than 2 MB")
            setValue('certificateFile', '')
            setPoliciesfilesErrorMessage('please upload a file')
            setnocallapi(true)
            return false;

        } else {

            if (data.target.files.length === 1) {
                var temp = data.target.files[0].type;

                if (temp == "application/pdf" || temp == "image/png" || temp == "image/jpeg") {

                } else {
                    setValue("certificateFile", "")
                    setPoliciesfilesErrorMessage('Please select valid file')
                    setImageName("")
                    setHaveImage(false)
                    setnocallapi(true)
                    return false

                }
                setPoliciesfilesErrorMessage('')
                setHaveImage(true)
                setImageName(updatedImageValue)

            } else {
                setPoliciesfilesErrorMessage('This field is required')
                setDisable(false)
                setHaveImage(false)

                setImageName("")
            }

        }

    }

    const validateSecondForm = (keyEventValues) => {
        const errors = {};
        const requiredKeys = ["ticket_category_id", "sub_category_id"];
        const displayNames = ["Category", "Subcategory"];
        requiredKeys.forEach((key, index) => {
            if (
                !(key in keyEventValues) ||
                keyEventValues[key] === undefined ||
                keyEventValues[key] === ""
            ) {
                errors[key] = `${displayNames[index]} is required`;
            }
        });
        return errors;
    };

    const handleGoButtonClick = () => {
        const keyEventValues = getValues();
        const checkSecondFrmKeyValues = Object.values(keyEventValues).some(
            (value) => value !== undefined || value !== ""
        );
        if (checkSecondFrmKeyValues) {
            const secondFormErrors = validateSecondForm(keyEventValues);
            if (Object.keys(secondFormErrors).length > 0) {
                setSecondFormErrors(secondFormErrors);
                return;
            }
        }
        setSecondFormErrors({});
        const selectedIssueType = watch("ticket_category_id");
        if (!selectedIssueType || selectedIssueType === "0") {
            setShowCommentAndFile(false);
        } else {
            setShowCommentAndFile(true);
        }
    };

    const validateFileSize = (value) => {
        if (!value) return true;
        const fileSize = value[0]?.size;
        const maxFileSize = 2 * 1024 * 1024;
        if (fileSize > maxFileSize) {
            return "File size exceeds the maximum allowed size (2 MB).";
        }
        return true;
    };

    const MAX_FILES = 5;
    const MAX_SIZE_MB = 2;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    const [fileError, setFileError] = useState("");
    const handleChange = (e) => {
        const newFiles = Array.from(e.target.files);
        const currentFiles = documents.length;
        const newFileCount = newFiles.length;
        const totalFiles = currentFiles + newFileCount;

        let error = "";
        if (totalFiles > MAX_FILES) {
            error = `You can only upload a maximum of ${MAX_FILES} files.`;
            setFileError(error);
            return;
        }
        const allowedExtensions = [".docx", ".pdf", ".jpg", ".jpeg", ".png", ".csv", ".txt", ".xlsx",".mp4"];
        const validFiles = newFiles.filter(file => {
            const fileName = file.name.toLowerCase();
            const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
            if (!isValidExtension) {
                error = `File ${file.name} is not a supported file type.`;
                setFileError(error);
                return false;
            }
            if (file.size > MAX_SIZE_BYTES) {
                error = `File ${file.name} exceeds the maximum size of ${MAX_SIZE_MB}MB.`;
                setFileError(error);
                return false;
            }
            return true;
        });

        setDocuments(prevFiles => [...prevFiles, ...validFiles]);
        setSelectedFileNames(prevFileNames => [
            ...prevFileNames,
            ...validFiles.map(file => file.name)
        ]);

        if (!error) {
            setFileError("");
        }
    };




    const options = {
        plugins: plugins,
        height: 250,

        // katex: katex,
        lang: en,
        buttonList: [
            [
                "font",
                "fontSize",
                "formatBlock",
                "bold",
                "underline",
                "italic",
                "paragraphStyle",
                "blockquote",
                "strike",
                "subscript",
                "superscript",
                "fontColor",
                "hiliteColor",
                "textStyle",
                "removeFormat",
                "undo",
                "redo",
                "outdent",
                "indent",
                "align",
                "horizontalRule",
                "list",
                "lineHeight",
                "table",
                "link",
                "image",
                "video",
                "audio",
                // You must add the 'katex' library at options to use the 'math' plugin.
                // 'math',
                // You must add the "imageGalleryUrl".

                "fullScreen",
                "showBlocks",
                "codeView",
                "preview",
                "print",
            ],
        ],
    };

    const closeTicket = () => {
        setSucess(false)
        navigate('/support');
    }
    const cancelTicket = () => {
        setSucess(false)
        navigate('/support');
    }
    const removeFile = (index) => {
        const updatedFileNames = [...selectedFileNames];
        updatedFileNames.splice(index, 1);
        setSelectedFileNames(updatedFileNames);

        const updatedDocuments = [...documents];
        updatedDocuments.splice(index, 1);
        setDocuments(updatedDocuments);
        document.getElementById('formFile').value = '';
    };

    return (
        <>
            <section id="content-wrapper">
            <ScheduleDemo showBanner={true} />
                <Grid container spacing={3} mt={2}>
                    <Grid item xs={12}>
                        <Box className="card-body pb-5">
                            {isLoadingCreate && (
                                <Box className="loader-overlay text-white">
                                    {/* Loader */}
                                </Box>
                            )}
                            <form onSubmit={handleSubmit(postTicketCreated)}>
                                <Grid container spacing={3}>
                                    {/* Category Type */}
                                    {/* Category Type */}
                                    <Grid item md={3}>
                                        <FormControl
                                            variant="standard"
                                            margin="normal"
                                            fullWidth
                                            error={!!errors.ticket_category_id}
                                            sx={{ width: { xs: '100%', sm: '100%' } }}
                                        >
                                            <Typography variant="body2" gutterBottom>
                                                Category Type <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <Select
                                                variant="outlined"
                                                defaultValue=""
                                                displayEmpty
                                                {...register('ticket_category_id', {
                                                    required: 'Category is required.',
                                                })}
                                                onChange={(e) =>{clearErrors('ticket_category_id'); parentTicketChange(e.target.value)}}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                            overflowY: 'auto',
                                                        },
                                                    },
                                                }}
                                                sx={{ maxHeight: '40px' }}
                                            >
                                                <MenuItem value="">Select Category Type</MenuItem>
                                                {getParentTicket?.length > 0 &&
                                                    getParentTicket.map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>
                                                            {item.parent_cat_name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                            {errors.ticket_category_id && (
                                                <Typography variant="body2" color="error">
                                                    {errors.ticket_category_id.message}
                                                </Typography>
                                            )}
                                            {!errors.ticket_category_id && secondFormErrors.ticket_category_id && (
                                                <Typography variant="body2" color="error">
                                                    {secondFormErrors.ticket_category_id}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Grid>

                                    {/* Sub Category */}
                                    <Grid item md={3}>
                                        <FormControl
                                            variant="standard"
                                            margin="normal"
                                            fullWidth
                                            error={!!errors.sub_category_id}
                                            sx={{ width: { xs: '100%', sm: '100%' } }}
                                        >
                                            <Typography variant="body2" gutterBottom>
                                                Sub Category <span style={{ color: 'red' }}>*</span>
                                            </Typography>
                                            <Select
                                                variant="outlined"
                                                defaultValue=""
                                                displayEmpty
                                                {...register('sub_category_id', {
                                                    required: 'Sub Category is required',
                                                })}
                                                onChange={(e) => {clearErrors('sub_category_id')}}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                            overflowY: 'auto',
                                                        },
                                                    },
                                                }}
                                                sx={{ maxHeight: '40px' }}
                                            >
                                                <MenuItem value="">Select Subcategory</MenuItem>
                                                {getChildTicket?.length > 0 ? (
                                                    getChildTicket.map((cat, index) => (
                                                        <MenuItem key={index} value={cat.id}>
                                                            {cat.ticket_category_name}
                                                        </MenuItem>
                                                    ))
                                                ) : (
                                                    <MenuItem value="">No data available</MenuItem>
                                                )}
                                            </Select>
                                            {errors.sub_category_id && (
                                                <Typography variant="body2" color="error">
                                                    {errors.sub_category_id.message}
                                                </Typography>
                                            )}
                                            {!errors.sub_category_id && secondFormErrors.sub_category_id && (
                                                <Typography variant="body2" color="error">
                                                    {secondFormErrors.sub_category_id}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Grid>


                                    {/* Comment / SunEditor */}
                                    <Grid item xs={12}>
                                        <Typography fontWeight="bold" gutterBottom>
                                            Comment <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                        <Controller
                                            name="ticket_desc"
                                            control={control}
                                            defaultValue=""
                                            rules={{ required: 'Comment is required' }}
                                            render={({ field, fieldState }) => (
                                                <div>
                                                <SunEditor
                                                    placeholder="Please type here..."
                                                    lang="en"
                                                    setDefaultStyle="font-family: Arial; font-size: 14px;"
                                                    setOptions={options}
                                                    onChange={(content) => {
                                                    const cleaned = content.replace(/<[^>]+>/g, '').trim();
                                                    field.onChange(content);
                                                    if (!cleaned) {
                                                        field.onChange('');
                                                    }
                                                    }}
                                                    onBlur={field.onBlur}
                                                    setContents={field.value}
                                                />
                                                </div>
                                            )}
                                            />

                                        {errors.ticket_desc && (
                                            <Typography color="error" fontSize="14px" mt={1}>
                                                {errors.ticket_desc.message}
                                            </Typography>
                                        )}
                                    </Grid>

                                    {/* File Upload */}
                                    <Grid item md={3}>
                                        <Typography fontWeight="bold">
                                            Choose files 
                                        </Typography>
                                        <TextField
                                            value={
                                                selectedFileNames.length
                                                    ? selectedFileNames.join(', ')
                                                    : 'No file chosen'
                                            }
                                            fullWidth
                                            onClick={() => document.getElementById('formFile').click()}
                                            InputProps={{ readOnly: true }}
                                            sx={{ cursor: 'pointer', mb: 1 }}
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                const droppedFiles = Array.from(e.dataTransfer.files);
                                                handleChange({ target: { files: droppedFiles } });
                                              }}
                                              onDragOver={(e) => e.preventDefault()}
                                        />
                                        <input
                                            id="formFile"
                                            type="file"
                                            style={{ display: 'none' }}
                                            accept=".docx, .pdf, .jpg, .jpeg, .png, .csv, .txt, .xlsx, .mp4"
                                            multiple
                                            onChange={handleChange}
                                        />
                                        {fileError && (
                                            <Typography color="error" fontSize="14px">
                                                {fileError}
                                            </Typography>
                                        )}
                                        {selectedFileNames.map((fileName, index) => (
                                            <Typography color="primary" key={index}>
                                                {fileName}
                                                <span
                                                    className="text-danger ms-2"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => removeFile(index)}
                                                >
                                                    <IconXboxX style={{ fontSize: '1.2em', verticalAlign: 'middle' }} />
                                                </span>
                                            </Typography>
                                        ))}
                                        <Typography variant="body2" mt={1}>
                                            <strong>Accepted file types:</strong><br/> (.docx, .pdf, .jpg, .jpeg, .png, .csv, .txt, .xlsx, .mp4)
                                        </Typography>
                                        <Typography className="text-danger font-bold">{PoliciesfilesErrorMessage}</Typography>
                                        <Typography className="text-danger">{error}</Typography>
                                        <Typography className="text-danger">{error1}</Typography>
                                    </Grid>

                                    {/* Submit Buttons */}
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                                            <Button variant="contained" color="warning" onClick={cancelTicket} disabled={buttonDisable}>
                                                Cancel
                                            </Button>
                                            {!buttonDisable ? (
                                                <Button variant="contained" type="submit" className="button2" disabled={buttonDisable}>
                                                    Create Ticket
                                                </Button>
                                            ) : (
                                                <Button variant="contained" disabled>
                                                    <CircularProgress size={30} />
                                                </Button>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </form>
                        </Box>
                    </Grid>
                </Grid>

                {/* </div> */}
                {/* </div> */}

                <Dialog open={success}  fullWidth>
                    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        Success
                    </DialogTitle>
                    <Divider />

                    <DialogContent sx={{ textAlign: "center" }}>
                        <Box sx={{ textAlign: "center", mb: 2 }}>
                            <IconButton sx={{ backgroundColor: "#c6f1d1", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
                                <IconCheck color="#198b08" size={50} />
                            </IconButton>
                        </Box>
                        Created Ticket successfully!
                    </DialogContent>
                    <Divider />
                    <DialogActions sx={{ justifyContent: "flex-end" }}>
                        <Button onClick={closeTicket} color="success" variant="contained">
                            Okay
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={sizepoup}>
                <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        Error
                        <IconButton
                        aria-label="close"
                        onClick={() => setSizePop(false)}
                        sx={{
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                        <IconX />
                        </IconButton>
                    </DialogTitle>
                <Divider/>
                <DialogContent>
                    <Typography>Your file exceeds the maximum allowed size.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setSizePop(false)} variant="contained" color="primary">
                    OK
                    </Button>
                </DialogActions>
                </Dialog>
            </section>
        </>
    );
};

export default CreateTicket;
